var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCameraFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00352 11.4016C9.329 11.4016 10.4035 10.327 10.4035 9.00156C10.4035 7.67608 9.329 6.60156 8.00352 6.60156C6.67803 6.60156 5.60352 7.67608 5.60352 9.00156C5.60352 10.327 6.67803 11.4016 8.00352 11.4016Z",
    fill: "#CCCFD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 1.5L4.3775 3H2C1.175 3 0.5 3.675 0.5 4.5V13.5C0.5 14.325 1.175 15 2 15H14C14.825 15 15.5 14.325 15.5 13.5V4.5C15.5 3.675 14.825 3 14 3H11.6225L10.25 1.5H5.75ZM8 12.75C5.93 12.75 4.25 11.07 4.25 9C4.25 6.93 5.93 5.25 8 5.25C10.07 5.25 11.75 6.93 11.75 9C11.75 11.07 10.07 12.75 8 12.75Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCameraFill);
export default __webpack_public_path__ + "static/media/icon-camera-fill.c8147baf464b60c1f090c914a2f805da.svg";
export { ForwardRef as ReactComponent };